import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RegionEnum } from "@edp-enums/region.enum";
import { GetContracts, GetPendingContracts, ShowContractSelection } from "@edp-store/actions/contract.actions";
import { GetContractsEs, ShowContractSelectionEs } from "@edp-store/actions/ES/contract-es.actions";
import { GetOperations } from "@edp-store/actions/operations.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { select, Store } from "@ngrx/store";
import { RegionService } from "./region.service";

@Injectable({
    providedIn: "root",
})
export class RegionActionsService {
    private region: string;

    constructor(
        regionService: RegionService,
        private router: Router,
        private store: Store<IAppState>,
        private storeES: Store<IAppEsState>
    ) {
        this.region = regionService.getRegion();
    }

    public getContracts() {
        if (this.region === RegionEnum.ES) {
            this.store.dispatch(new GetContractsEs());
            return;
        }
        this.store.dispatch(new GetContracts());
        this.store.dispatch(new GetPendingContracts());
        this.store.dispatch(new GetOperations());
    }

    public showContractSelection() {
        if (this.region === RegionEnum.ES) {
            this.store.dispatch(new ShowContractSelectionEs());
            return;
        }
        this.store.dispatch(new ShowContractSelection());
    }

    public goToStartPage() {
        if (this.region === RegionEnum.ES) {
            this.storeES.pipe(select(getContractEs)).subscribe(contract => {
                if (!!contract) {
                    this.router.navigate([`energia/${contract.id}/inicio`]);
                }
            });
            return;
        }
        this.store.pipe(select(getContract)).subscribe(contract => {
            if (!!contract) {
                this.router.navigate([`energia/${contract.ContractId}/inicio`]);
            }
        });
    }
}
